import { Box } from "@mui/material";
import { ReactNode } from "react";
import {
  HUB_COLORS,
  HUB_SIZE,
  INNER_RING_RADIUS,
  OUTER_RING_RADIUS,
} from "./hubConfig";

const HomePageCircles = ({ children }: { children: ReactNode }) => {
  const center = HUB_SIZE / 2;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: { xs: "22rem", sm: "36rem", md: "44rem", lg: "50rem" },
          height: { xs: "22rem", sm: "36rem", md: "44rem", lg: "50rem" },
          backgroundColor: "#D2E2FF",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            width: { xs: "19rem", sm: "31rem", md: "38rem", lg: "43rem" },
            height: { xs: "19rem", sm: "31rem", md: "38rem", lg: "43rem" },
            backgroundColor: "#f3f4f6",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: HUB_SIZE,
              height: HUB_SIZE,
              flexShrink: 0,
              transform: {
                xs: "scale(0.58)",
                sm: "scale(0.72)",
                md: "scale(0.85)",
                lg: "scale(1)",
              },
            }}
          >
            <Box
              component="svg"
              viewBox={`0 0 ${HUB_SIZE} ${HUB_SIZE}`}
              sx={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
              }}
            >
              <circle
                cx={center}
                cy={center}
                r={INNER_RING_RADIUS}
                fill="none"
                stroke={HUB_COLORS.ring}
                strokeWidth="2"
              />
              <circle
                cx={center}
                cy={center}
                r={OUTER_RING_RADIUS}
                fill="none"
                stroke={HUB_COLORS.ring}
                strokeWidth="2"
              />
            </Box>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HomePageCircles;
